import { ERROR_TYPE, HB_EVENT_NAME } from "src/constant";
import getUniqueStr from "./get-unique-str";

export default function getErrorEventFromRequest(reqEvent: HBEventData): HBEventData {
  return {
    ...reqEvent,
    en: HB_EVENT_NAME.ERROR,
    et: ERROR_TYPE.HttpError,
    ec: 'E01000',
    eid: getUniqueStr(reqEvent.evt),
    // eid: reqEvent.eid.replace(/^.{3}/, (substr) => substr !== 'err' ? 'err' : 'er2'), // 更换唯一eid
    rtiming: undefined,
    attrs: Object.assign({ rEid: reqEvent.eid }, reqEvent.attrs),
  };
}
